(() => {
  if (window.__preaRelatedProductsViewMore) return;
  window.__preaRelatedProductsViewMore = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-related-products-view-more]');
    if (!button) return;

    const recommendations = button.closest('product-recommendations');
    if (!recommendations) return;

    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const hiddenClass = isDesktop
      ? 'related-products__item--hidden-desktop'
      : 'related-products__item--hidden-mobile';
    const nextItems = Array.from(recommendations.querySelectorAll(`.${hiddenClass}:not(.is-load-more-visible)`)).slice(0, 6);
    const control = button.closest('.related-products__view-all');
    const status = control?.querySelector('[data-related-products-load-more-status]');

    if (!nextItems.length) {
      control?.setAttribute('hidden', '');
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    nextItems.forEach((item, index) => {
      item.style.setProperty('--prea-load-more-index', String(index));
      item.classList.add('is-load-more-visible', 'is-load-more-revealing');
      item.addEventListener('animationend', () => {
        item.classList.remove('is-load-more-revealing');
        item.style.removeProperty('--prea-load-more-index');
      }, { once: true });
    });

    const animationDuration = 70 * Math.max(nextItems.length - 1, 0) + 680;
    window.setTimeout(() => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-expanded', 'true');
      control?.setAttribute('hidden', '');
      if (status) {
        const total = recommendations.querySelectorAll('.related-products__item').length;
        status.textContent = `Showing all ${total} products.`;
      }
    }, animationDuration);
  });
})();
